import React from 'react';
import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import type {
  SingleSparkStepReferenceResponse,
  SparkReferenceInputParameter,
} from 'types/SparkStepReference';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

const getSparkStepsReferences = (stepID: string | undefined) => {
  const url = generateURL(
    SPARK_RESOURCE_TYPES.SPARK_STEP_REFERENCES,
    [],
    stepID
  );

  return fetchWrapper<SingleSparkStepReferenceResponse>({
    url: url,
    method: 'GET',
  });
};

export function useSparkStepReferences(stepID?: string) {
  const queryResponse = useQuery(
    ['sparkStepReferences', stepID],
    () => getSparkStepsReferences(stepID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Fetch Spark Step References: ${error.message}`
          );
        }
      },
      enabled: Boolean(stepID),
      ...CACHE_AND_STALE_TIME,
    }
  );

  const { sparkInputParameters, sparkSteps } =
    queryResponse.data?.data.attributes || {};

  const sparkInputParametersReferenceIDmap = React.useMemo(() => {
    return sparkInputParameters?.reduce<
      Record<string, SparkReferenceInputParameter>
    >((acc, curr) => {
      return { ...acc, [curr.id]: curr };
    }, {});
  }, [sparkInputParameters]);

  return {
    ...queryResponse,
    sparkInputParametersReferenceIDmap,
    sparkSteps,
    sparkInputParameters,
  };
}
